
import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import "./FDMISCloserRequest.css";
import { Link, useNavigate } from "react-router-dom";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

const secondaryTabs = ["All", "Active", "Closed", "Pre-Closed", "Reject"];
const rowsPerPage = 10;

const RDReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [activeMainTab, setActiveMainTab] = useState("FD");
  const [activeSecondary, setActiveSecondary] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { profile } = useSelector((state) => state.userProfile);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
     const [closerDate, setCloserDate] = useState("");
        const [closerRemark, setCloserRemark] = useState("");
          const [accountCloseDialog, setAccountCloseDialog] = useState({
            open: false,
            accountId: null,
          });

  // ---------------------- EMI View Handler -----------------------
  const handleViewEmi = (account) => {
    navigate(`/Deposit/EmiDetails/${account.id}`, { state: { account } });
  };

  // ---------------- Fetch Profile on Load -------------------------
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // --------------------- FETCH ACCOUNTS ---------------------------
  const fetchAccounts = async () => {
    try {
      setLoading(true);

      const superAdminId = Number(profile?.superAdminId) || 14;
      const branchId =
        Number(profile?.branchId) ||
        Number(localStorage.getItem("userId")) ||
        56;

      const createdBy = Number(localStorage.getItem("userId")) || 56;

      const res = await axios.get(`https://payyug.in/api/fdmis/all-new`, {
        params: {
          superAdminId,
          branchId,
          createdBy,
          page: currentPage,
          limit: rowsPerPage,
          accountType: activeMainTab,
          status: activeSecondary !== "All" ? activeSecondary : undefined,
          search: searchQuery || undefined,
        },
      });

      console.log("FD/MIS Deposit List:", res.data);

      if (res.data?.success) {
        setAccounts(res.data.data || []);
        setTotalPages(res.data.totalPages || 1);
      } else {
        setAccounts([]);
      }
    } catch (err) {
      console.error("Error fetching deposit accounts:", err);
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  };

  // Call when filters change
  useEffect(() => {
    fetchAccounts();
    // eslint-disable-next-line
  }, [activeMainTab, activeSecondary, searchQuery, currentPage, profile]);

  // Reset pagination when main filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [activeMainTab, activeSecondary]);


    const openAccountCloseDialog = (accountId) => {
      setAccountCloseDialog({ open: true, accountId });
    };
  
    const closeAccountCloseDialog = () => {
      setAccountCloseDialog({ open: false, accountId: null });
      setCloserDate("");
      setCloserRemark("");
    };
  
    const handleFDMISAccountClose = async (e) => {
      e.preventDefault();
  
      if (!closerDate || !closerRemark) {
        toast.error("Date and remark required");
        return;
      }
  
      try {
        const res = await axios.put(
          // `https://payyug.in/api/saving-account/request-close/${accountCloseDialog.accountId}`,
          {
            closureRemark: closerRemark,
            closureDate: closerDate,
          }
        );
  
        console.log(res);
        toast.success("Account closed successfully");
        fetchAccounts();
        closeAccountCloseDialog();
      } catch (err) {
        toast.error(err?.response?.data?.message||"Failed to close saving account");
        // console.error(err);
      }
    };


  // ===================== RENDER TABLE ============================
  const renderTable = useMemo(() => {
    if (loading) {
      return (
        <tr>
          <td colSpan="5" style={{ textAlign: "center" }}>Loading...</td>
        </tr>
      );
    }

    if (!accounts.length) {
      return (
        <tr>
          <td colSpan="5"  style={{ textAlign: "center" }}>No Data Found</td>
        </tr>
      );
    }

    return accounts.map((acc, index) => {
      const isPending = acc.status === "Pending";

      return (
        <tr key={acc.id}>
          {/* SN */}
          <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>

          {/* Account No */}
          <td>{acc.accountNumber || acc.accountNo || "--"}</td>

          {/* Customer Name */}
          <td>{acc.customer.fullName || "--"}</td>

          {/* Account Type */}
          <td>{acc.accountType || "--"}</td>

          {/* ROI */}
          {/* <td>{acc.roi || "--"}%</td> */}

          {/* Tenure */}
          {/* <td>{acc.tenureMonths || acc.tenure || "--"}</td> */}

          {/* Maturity Amount */}
          {/* <td>₹{acc.maturityAmount?.toLocaleString() || "--"}</td> */}

          {/* Maturity Date */}
          {/* <td>{new Date(acc.maturityDate).toLocaleDateString() || "--"}</td> */}

          {/* Total Interest */}
          {/* <td>₹{acc.totalInterest?.toLocaleString() || "--"}</td> */}
          {/* Monthly Interest (only for MIS) */}
          {/* {activeMainTab === "MIS" && (
            <td>₹{acc.monthlyInterest?.toLocaleString() || "--"}</td>
          )} */}

          {/* Action */}
          {/* <td>
            {isPending ? (
              <span className="status-badge-not-approved">Not Approved</span>
            ) : (
              <button
                className="DDFDReportview-btn"
                onClick={() => handleViewEmi(acc)}
              >
                View
              </button>
            )}
          </td> */}

          <td>
                   {acc.status==="CloseRequested"?(
                     <button
                      className="fdmis-account-close-req-action-btn"
                       disabled
                            title="Account close Requested"
                            aria-disabled="true"
                    >
                      Requested
                    </button>
                   ):acc.status==="closed"?(
                    <button
                      className="fdmis-account-close-req-action-btn"
                       disabled
                            title="Account already closed"
                            aria-disabled="true"
                    >
                      Closed
                    </button>
                   ):(
                     <button
                      className="fdmis-account-close-req-action-btn"
                      onClick={() => openAccountCloseDialog(acc.id)}
                    >
                      Close
                    </button>
                   )}
                  </td>
        </tr>
      );
    });
  }, [accounts, loading, currentPage]);

  return (
    <div className="fdmis-account-close-req-container">
      <h2 style={{ textAlign: "center", marginBottom: 10 }}>
        {activeMainTab} Account Close Request
      </h2>

      {/* Main Tabs */}
      <div className="fdmis-account-close-req-changing-main-tabs">
        {["FD", "MIS"].map((tab) => (
          <button
            key={tab}
            className={`fdmis-account-close-req-changing-main-btn ${activeMainTab === tab ? "active" : ""}`}
            onClick={() => setActiveMainTab(tab)}
          >
            {tab} Report
          </button>
        ))}
      </div>

      {/* Secondary Tabs */}
      <div className="fdmis-account-close-req-changing-secondary-tabs">
        {secondaryTabs.map((tab) => (
          <button
            key={tab}
            className={`fdmis-account-close-req-changing-secondary-btn ${
              activeSecondary === tab ? "active" : ""
            }`}
            onClick={() => setActiveSecondary(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Search */}
      <div className="fdmis-account-close-req-searchbox">
        <input
          type="text"
          placeholder="Search by Account No / Customer..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {/* Table */}
      <div className="fdmis-account-close-req-table-container">
        <table className="fdmis-account-close-req-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Account No</th>
              <th>Customer Name</th>
              <th>Account Type</th>
              {/* <th>ROI</th>
              <th>Tenure</th>
              <th>Maturity Amount</th>
              <th>Maturity Date</th>
              <th>Total Interest</th>
              {activeMainTab === "MIS" && <th>Monthly Interest</th>}
              <th>Certificate</th> */}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>{renderTable}</tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="fdmis-account-close-req-pagination-section">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          Previous
        </button>

        <span>Page {currentPage} of {totalPages}</span>

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next
        </button>
      </div>


             {/* Loan Close Confirmation Dialog */}
      {accountCloseDialog.open && (
        <div className="account-closer-dialog-overlay">
          <div className="account-closer-dialog">
            <h3>{activeMainTab} Account Close Confirmation</h3>

            <form onSubmit={handleFDMISAccountClose}>
              <input
                type="date"
                value={closerDate}
                onChange={(e) => setCloserDate(e.target.value)}
              />
              <input
                type="text"
                placeholder="Remark"
                value={closerRemark}
                onChange={(e) => setCloserRemark(e.target.value)}
              />

              <div className="account-closer-dialog-buttons">
                <button type="submit" className="btn-confirm">
                  Close
                </button>
                <button
                  type="button"
                  onClick={closeAccountCloseDialog}
                  className="btn-cancel"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default RDReport;
